import { useEffect } from "react";
import { AppProviders } from "./app/AppProviders";
import { OpsPortalRouter } from "./app/ops-router";
import { AppRouter } from "./app/router";
import { clearChunkReloadFlag } from "./lib/chunk-load-recovery";
import { isOpsPortalHost } from "./lib/ops-host";

export default function App() {
  useEffect(() => {
    const t = window.setTimeout(() => clearChunkReloadFlag(), 4000);
    return () => window.clearTimeout(t);
  }, []);

  const opsPortal = isOpsPortalHost();
  return (
    <AppProviders>
      {opsPortal ? <OpsPortalRouter /> : <AppRouter />}
    </AppProviders>
  );
}
